<template>
  <div></div>
</template>
<script>

import {cleanQueryFromTagsinputToSearch} from '../../assets/scripts/search'

export default {
  data () {
    return {
    }
  },
  methods: {
    mixinFollowSearch: function (query, listType, listId) {
      listType = listType.replace('author', '0').replace('patent', '1').replace('company', '3')
      let search = cleanQueryFromTagsinputToSearch(query).toLowerCase()

      let data = {
        search: search,
        list_id: listId !== null ? parseInt(listId) : null,
        search_type: parseInt(listType)
      }

      this.axios.post('follow/search', data).then((response) => {
        this.$notify({
          type: 'success',
          title: '',
          content: 'Done !',
          placement: 'bottom-right'
        })

        this.getFollowedSearches()
      }).catch((error) => {

      })
    },
    mixinUnFollowSearch: function (followedSearchId) {
      if (typeof followedSearchId !== 'undefined' && followedSearchId !== null) {
        this.axios.delete('follow/search/' + followedSearchId).then(() => {
          this.$notify({
            type: 'success',
            title: '',
            content: 'Done !',
            placement: 'bottom-right'
          })
          this.getFollowedSearches()
        }).catch((error) => {

        })
      }
    },
    getFollowedSearches: function () {
      let url = 'follow/search/' + (this.listId !== null && typeof this.listId !== 'undefined' ? this.listId : '')

      this.axios.get(url).then((response) => {
        this.$emit('update:followedSearches', response.data)
      }).catch((error) => {

      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Mixins/FollowSearch.vue